import { CheckIcon } from 'lucide-react-native';
import * as React from 'react';
import { View } from 'react-native';

import { BRAND } from '@sixam/config/brand';
import { Icon } from '@sixam/ui/icon';
import { Text } from '@sixam/ui/text';

/**
 * What a runner sees the moment an operator scans them. Shown in place of their
 * code, because once they are on the roster the code has nothing left to do.
 *
 * One component so the answer is identical wherever the code was being shown
 * from — the event screen a registered runner lands on, or the profile code a
 * walk-up holds up.
 */
export function CheckedInConfirmation({ eventTitle }: Readonly<{ eventTitle?: string | null }>) {
  return (
    <View
      className="w-full items-center gap-4 rounded-md p-8"
      style={{ backgroundColor: BRAND.color.success }}
    >
      <View className="size-20 items-center justify-center rounded-full bg-white/20">
        <Icon as={CheckIcon} className="size-12 text-white" />
      </View>
      <Text className="text-center text-2xl font-bold text-white">You are checked in</Text>
      {eventTitle ? (
        <Text className="text-center text-white/80">See you at {eventTitle}. Have a good run.</Text>
      ) : null}
    </View>
  );
}
